/**
 * Повертає поточний локальний час у форматі ISO без Z: "YYYY-MM-DDTHH:MM:SS"
 * Використовується для T3 полів (*_ldt) при відправці на бекенд.
 *
 * ❌ НЕ використовувати: new Date().toISOString().slice(0, 19) — дає UTC
 * ✅ Використовувати: localNowIso() — дає локальний час браузера
 */
export function localNowIso(): string {
  return new Date().toLocaleString('sv-SE').replace(' ', 'T').slice(0, 19);
}

/**
 * Конвертує Date-об'єкт у локальний ISO рядок без Z: "YYYY-MM-DDTHH:MM:SS"
 * Використовується для T3 полів (*_ldt) при відправці на бекенд.
 *
 * ❌ НЕ використовувати: date.toISOString().slice(0, 19) — дає UTC
 * ✅ Використовувати: toLocalIso(date) — дає локальний час браузера
 */
export function toLocalIso(date: Date): string {
  return date.toLocaleString('sv-SE').replace(' ', 'T').slice(0, 19);
}

const DEFAULT_TIMEZONE = 'Europe/Kyiv';

/**
 * Поточний місцевий час у вказаному поясі (IANA) у форматі "YYYY-MM-DDTHH:MM:SS" - для порівняння з T3 полями
 * (*_ldt) користувача, який живе в іншому поясі, ніж браузер. Пояс не заданий або некоректний - Europe/Kyiv.
 */
export function nowIsoInTimezone(timezone?: string | null, now: Date = new Date()): string {
  const format = (timeZone: string) => now.toLocaleString('sv-SE', { timeZone }).replace(' ', 'T').slice(0, 19);
  try {
    return format(timezone || DEFAULT_TIMEZONE);
  } catch {
    return format(DEFAULT_TIMEZONE);
  }
}
